import { Column, RightDrawer, Spacer } from '../../components';
import { logo3NSmall } from '../../assets/png';
import { Svgs } from '../../assets/svg';
import { useDeviceType } from '../../hooks/useDeviceType';
import { LearnMoreDrawerProps } from './Types';
import { PackageCard } from '../components/PackageCard';
import {
  AtAGlanceSection,
  DescriptionSection,
  DrawerHeader,
  YourLifeGoals,
  SvgBulletRow,
  CloseButton,
} from './components';

const LearnMoreAdviceDrawer: React.FC<LearnMoreDrawerProps> = ({
  drawerOpen,
  setDrawerOpen,
  pricebookBundle,
  pricebookMetadata,
}) => {
  const { isMobile } = useDeviceType();

  return (
    <RightDrawer open={drawerOpen} setOpen={setDrawerOpen}>
      <DrawerHeader
        isMobile={isMobile}
        pricebookName={pricebookBundle.pricebook.pricebookName}
        setDrawerOpen={setDrawerOpen}
        logo={logo3NSmall}
      />
      <PackageCard pricebookBundle={pricebookBundle} pricebookMetadata={pricebookMetadata} />
      {isMobile && (
        <>
          <Spacer height='xs' />
          <Column style={{ alignItems: 'center' }}>
            <Svgs.ArtPieChart style={{ maxWidth: '115px', minWidth: '100px' }} />
          </Column>
        </>
      )}
      <Spacer height='xxs' />
      <DescriptionSection
        description='YouDontHaveToChoose'
        art={<Svgs.ArtPieChart style={{ marginLeft: '20px', marginRight: '20px' }} />}
        isMobile={isMobile}
      />
      <Spacer height={isMobile ? 'sm' : 'xxs'} />
      <AtAGlanceSection
        bullets={[
          <SvgBulletRow
            art={<Svgs.BulletInvestment style={{ width: '50px', height: 'auto', flexShrink: 0 }} />}
            text={'ObjectiveInvestmentAdvice'}
          />,
          <SvgBulletRow
            art={<Svgs.BulletPiggyBank style={{ width: '50px', height: 'auto', flexShrink: 0 }} />}
            text={'BudgetPlanner'}
          />,
          <SvgBulletRow
            art={<Svgs.BulletCalculator style={{ width: '50px', height: 'auto', flexShrink: 0 }} />}
            text={'CustomizableToolsStrong'}
          />,
          <SvgBulletRow
            art={<Svgs.BulletLessons style={{ width: '50px', height: 'auto', flexShrink: 0 }} />}
            text={'InteractiveCoursesStrong'}
          />,
        ]}
      />
      <YourLifeGoals isMobile={isMobile} />
      {!isMobile && <CloseButton setDrawerOpen={setDrawerOpen} />}
      <Spacer height='xxs' />
    </RightDrawer>
  );
};

export default LearnMoreAdviceDrawer;
